import { IPaginationResponse } from '@/interfaces/common.interface';
import {
  ECollectionItemType,
  ICollection,
  ICollectionItem,
  ICollectionsResponse,
} from '@/interfaces/doccen-lib/collection.interface';
import {
  ECollectionStatus,
  IUpdateContentLink,
} from '@/interfaces/doccen-lib/contentManagement.interface';
import { tmsHTTPRequest } from 'services/axios/httpRequest';

export const postDoccenCollection = async (body: {
  categoryId: number;
  description: string;
  name: string;
  thumbnail: File;
}) => {
  const { categoryId, thumbnail, description, name } = body;

  const formdata = new FormData();
  formdata.append('categoryId', String(categoryId));
  formdata.append('description', description);
  formdata.append('name', name);
  formdata.append('thumbnail', thumbnail, thumbnail.name);

  return tmsHTTPRequest.post<{
    id: string;
  }>(`/v1/collections`, formdata, {
    headers: {
      accept: 'multipart/form-data',
    },
  });
};

export const patchDoccenCollection = async (body: {
  collectionId: string;
  categoryId: number;
  description: string;
  name: string;
  thumbnail: File;
}) => {
  const { collectionId, categoryId, description, name, thumbnail } = body;

  const formdata = new FormData();
  formdata.append('categoryId', String(categoryId));
  formdata.append('description', description);
  formdata.append('name', name);
  formdata.append('thumbnail', thumbnail);

  return tmsHTTPRequest.patch<{ collectionId: string }>(
    `/v1/collections/${collectionId}`,
    formdata,
    {
      headers: {
        accept: 'multipart/form-data',
      },
    }
  );
};

export const deleteDoccenCollection = async (collectionId: string) =>
  tmsHTTPRequest.delete(`/v1/collections/${collectionId}`);

export const getDoccenCollections = async (
  status: ECollectionStatus,
  categoryId?: number
) =>
  tmsHTTPRequest.get<ICollectionsResponse>(`/v1/collections`, {
    params: {
      status,
      categoryId,
    },
  });

export const getDoccenCollection = async (collectionId: string) =>
  tmsHTTPRequest.get<ICollection>(`/v1/collections/${collectionId}`);

export const patchDoccenCollectionContentLink = ({
  contentLinkId,
  collectionId,
  ...data
}: IUpdateContentLink & {
  collectionId: string;
}) =>
  tmsHTTPRequest.patch<{ collectionId: string }>(
    `/v1/collections/${collectionId}/items/${contentLinkId}/content-link`,
    data
  );

export const postDoccenCollectionDocument = async (body: {
  collectionId: string;
  itemIds: Array<string>;
  type: ECollectionItemType;
}) => {
  const { collectionId, ...data } = body;
  return tmsHTTPRequest.post<{ collectionId: string }>(
    `/v1/collections/${collectionId}/items`,
    data
  );
};

export const deleteDoccenCollectionDocument = async (body: {
  collectionId: string;
  itemId: string;
}) => {
  const { collectionId, itemId } = body;
  return tmsHTTPRequest.delete<{ collectionId: string }>(
    `/v1/collections/${collectionId}/items/${itemId}`
  );
};

export const patchOrderDoccenCollectionDocument = async (body: {
  collectionId: string;
  itemId: string;
  newOrder: number;
}) => {
  const { collectionId, itemId, ...data } = body;
  return tmsHTTPRequest.patch<{ collectionId: string }>(
    `/v1/collections/${collectionId}/items/${itemId}/order`,
    data
  );
};

export const postPublishDoccenCollection = async (collectionId: string) =>
  tmsHTTPRequest.post<{ id: string }>(
    `/v1/collections/${collectionId}/publish`,
    {}
  );

export const patchHideDoccenCollection = async (collectionId: string) =>
  tmsHTTPRequest.patch<{ collectionId: string }>(
    `/v1/collections/${collectionId}/hide`,
    {}
  );

export const postSearchDoccenLibCollection = async (body: {
  categories: number[] | null;
  pageSize: number;
  pageNumber: number;
  query?: string;
}) =>
  tmsHTTPRequest.post<IPaginationResponse<ICollectionItem>>(
    `/v1/collections/search`,
    body
  );
